// extracted by mini-css-extract-plugin
module.exports = {"background":"style-module--background--3Q9mA"};